export const privacyProps = {
  basename: "/plataforma/configuracoes",
};
